// app/src/features/tracking/LimitPopup.jsx
import React from "react";
import { C } from "../../lib/colors.js";
import { surface, ui } from "../../lib/telemetry/instrument.js";

/**
 * "Your watchlist is full." The modal shown when a pin would take the watchlist past
 * `WATCHLIST_LIMIT`; dismissed by the backdrop, the OK button or on its own after 2.5 s (the
 * auto-hide is `useTrackingWiring`'s). Rendered beside `AppFrame` (not a frame slot), for the
 * phone and the desktop layouts alike, as the inline popup was.
 */
export default function LimitPopup({ ctx }) {
  const { watchlistLimitPopup, setWatchlistLimitPopup, WATCHLIST_LIMIT } = ctx;
  return (
    <>
      {watchlistLimitPopup && (
        <div
          onClick={() => setWatchlistLimitPopup(false)}
          {...surface("watchlist-full")}
          {...ui("watchlist-full.dismiss")}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 650,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "popupOverlayIn 0.22s ease-out",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            {...ui("watchlist-full.dialog")}
            style={{
              background: C.panel,
              border: `1px solid ${C.border}`,
              borderRadius: 12,
              padding: 24,
              width: 380,
              maxWidth: "90vw",
              boxShadow: C.shadowBox,
              animation: "popupPanelIn 0.32s cubic-bezier(0.16,1,0.3,1) both",
            }}
          >
            <div
              style={{
                fontSize: 15,
                color: C.white,
                marginBottom: 8,
                fontWeight: 600,
              }}
            >
              Your watchlist is full
            </div>
            <div style={{ fontSize: 13, color: C.grayL, lineHeight: 1.5, marginBottom: 16 }}>
              It holds up to <strong>{WATCHLIST_LIMIT}</strong> forecasts. Remove one to add
              another.
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => setWatchlistLimitPopup(false)}
                {...ui("watchlist-full.ok")}
                style={{
                  background: C.btnBg,
                  color: C.grayL,
                  border: `1px solid ${C.border}`,
                  borderRadius: 8,
                  padding: "6px 14px",
                  fontFamily: '"IBM Plex Mono",monospace',
                  fontSize: 12,
                  cursor: "pointer",
                  letterSpacing: 0,
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
